import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const popupContainerSX: SxProps = {
    flexDirection: globalBreak({mobile:'column-reverse', desktop:'row'}),
    '& > .MuiStack-root':{
        width: globalBreak({mobile:'100%', desktop:'50%'}),
    }
}

export const InfoPopupCloseIocnSX: SxProps = {
    position: 'absolute',
    right: 5,
    top: 8,
    fontSize: 22,
    cursor: 'pointer',
    bgcolor: '#fff',
    borderRadius: '50%',
    padding: 0.5,
    '&:hover':{
        bgcolor:'lightgray'
    },
    zIndex:1500
}